import { connect } from 'react-redux'

function AppPopUps(props) {
  const { } = props

  return (
    <>
      {/* {localStorage.getItem("User-Type") !== "non_admin" && <NewFeaturePopup />} */}
    </>
  )
}

const mapStateToProps = state => {
  const { } = state
  return {

  }
}

export default connect(mapStateToProps)(AppPopUps);